import { IntentKind, makeIntentGuard } from '@jet-app/music-classical/intents';
import type { Intent } from '@jet/environment/dispatching';

export interface QueryPlaybackIntent extends Intent<any> {
    $kind: IntentKind.QUERY_PLAYBACK_INTENT;
    query: string;
}

export const isQueryPlaybackIntent = makeIntentGuard<QueryPlaybackIntent>(
    IntentKind.QUERY_PLAYBACK_INTENT,
);

export function makePlaybackFromQueryIntent(
    options: Omit<QueryPlaybackIntent, '$kind'>,
): QueryPlaybackIntent {
    return {
        ...options,
        $kind: IntentKind.QUERY_PLAYBACK_INTENT,
    };
}
